export default {
  rank: 'E3',
  year: 2016,
  with: 897,
  with_change: '+4.2%',
  without: 732,
  without_change: '+1.7%',
}
